import { Modal } from "react-bootstrap";

export default function ConfirmationVoucherAddedToCartPage(props) {
    return (
        <>
            <Modal.Body className="wo-loy__body">
                <div className="wo-done">
                    <span className="wo-done__mark" aria-hidden="true">
                        <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                             strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M5 12.5l4.5 4.5L19 7.5" />
                        </svg>
                    </span>
                    <p className="wo-done__head">Voucher added</p>
                    <p className="wo-done__sub">It&rsquo;s in your basket, ready to use at checkout.</p>
                </div>
            </Modal.Body>
            <Modal.Footer className="wo-pm__foot">
                <div className="wo-pm__footBar">
                    <button type="button" className="wo-pm__add" onClick={props.handleClickCloseLoyaltyModal}>Done</button>
                </div>
            </Modal.Footer>
        </>
    )
}
